import { differenceInDays } from 'date-fns';

export function checkMinStayRule(
  minStay: number | null | undefined,
  propsDate: Date,
  selectedDates: any
) {
  const distance = differenceInDays(propsDate, selectedDates.from);
  const minStayFailed = typeof minStay === 'number' && distance < minStay;
  return !minStayFailed;
}

export function checkMaxStayRule(
  maxStay: number | null | undefined,
  propsDate: Date,
  selectedDates: any
) {
  const distance = differenceInDays(propsDate, selectedDates.from);
  const maxStayExceeded = typeof maxStay === 'number' && distance > maxStay;
  return maxStayExceeded;
}

